module.exports = __webpack_public_path__ + "static/media/google-play_icon.cd512baa.svg";